import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import useSeo from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

export default function Faq() {
  useSeo({
    title: "常见问题 - 17爆料网内容来源与核实说明",
    description:
      "17爆料网常见问题解答：内容来源、时间线整理方式、隐私信息处理原则、信息更正与线索投稿渠道，一次看懂网站的内容标准。",
    keywords: "常见问题,内容来源,信息核实,线索投稿,17爆料网",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://17baoliao.example.com/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "https://17baoliao.example.com/faq" },
        ],
      },
    ],
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <div className="w-full px-4 pt-6 md:px-8">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
        </div>

        <section className="w-full px-4 pb-8 pt-6 md:px-8">
          <h1 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇总了关于内容来源、核实方式、隐私处理与线索投稿的常见问题。如果没有找到答案，欢迎通过联系页面直接提问。
          </p>
        </section>

        <section className="w-full px-4 pb-14 md:px-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px] lg:items-start">
            <FaqAccordion items={faqs} />

            <aside className="flex flex-col gap-5 lg:sticky lg:top-24">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-customer-service-2-line text-lg text-secondary-600"></i>
                  还有疑问？
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  直接发邮件或通过联系页面留言，我们通常在一到两个工作日内回复。
                </p>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="mt-4 flex items-center gap-2 text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  <i className="ri-mail-send-line text-base"></i>
                  {siteInfo.email}
                </a>
                <Link
                  to="/contact"
                  className="mt-4 inline-flex w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  前往联系页面
                </Link>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h2 className="font-heading text-base font-bold text-foreground-950">热门内容</h2>
                <ul className="mt-3 flex flex-col gap-2.5">
                  <li>
                    <Link to="/topics?cat=rights" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer">
                      <i className="ri-shield-check-line text-base text-accent-600"></i>
                      消费维权整理
                    </Link>
                  </li>
                  <li>
                    <Link to="/topics?cat=scene" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer">
                      <i className="ri-live-line text-base text-accent-600"></i>
                      网络现场辨析
                    </Link>
                  </li>
                  <li>
                    <Link to="/topics?cat=deep" className="flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer">
                      <i className="ri-file-search-line text-base text-accent-600"></i>
                      深度梳理合集
                    </Link>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}